import { CloseProductDetailsPredictions } from '../../assets/icons/closeOption'
import { FacialCleanserIconProductPrediction } from '../../assets/icons/facial-cleanser'
import { usePredictionDetails } from '../../pages/PredictionDetails/usePredictionDetails'
import { colors } from '../../theme'
import { dateToBr } from '../../utils/transformDate'
import { CardDashboard } from '../CardDashboard/CardDashboard'
import { CardIconTitle } from '../CardIconTitle/CardIconTitle'
import { Loading } from '../Loading/Loading'
// import { Loading } from '../Loading/Loading'
import {
  ContainerCards,
  ContainerModalSend,
  ContainerTable,
  DivImg,
  Closed,
  SendStyle,
} from './styles'
import { TableProductDetailsPrediction } from './table'

type ProductDetailsPredictionsProps = {
  consumoMedioDiario: number
  dataCompraAntiga: string
  dataCompraRecente: string
  diasConsumo: number
  duracaoUltimaCompra: number
  nome: string
  predicaoProximaCompra: string
  quantidadeUltimaCompra: number
  reposicaoTotal: number
  handleIsProductDetails: () => void
}

export function ProductDetailsPredictions({
  consumoMedioDiario,
  dataCompraAntiga,
  dataCompraRecente,
  diasConsumo,
  duracaoUltimaCompra,
  nome,
  predicaoProximaCompra,
  quantidadeUltimaCompra,
  reposicaoTotal,
  handleIsProductDetails,
}: ProductDetailsPredictionsProps) {
  const { isLoading } = usePredictionDetails()
  const consumoMedio = consumoMedioDiario.toFixed(4)

  return (
    <ContainerModalSend>
      <SendStyle>
        <DivImg>
          <CardIconTitle
            icon={<FacialCleanserIconProductPrediction />}
            background={colors.grey200}
            title={nome}
            color={colors.grey900}
          />
          <Closed
            onClick={() => {
              handleIsProductDetails()
            }}
          >
            <CloseProductDetailsPredictions />
          </Closed>
        </DivImg>
        <ContainerCards>
          {isLoading ? (
            <Loading contrast={false} />
          ) : (
            <>
              <CardDashboard
                colorTitle={colors.grey900}
                color={colors.primaryText}
                background={colors.grey50}
                total={dateToBr(dataCompraRecente)}
              >
                Compra mais recente
              </CardDashboard>
              <CardDashboard
                colorTitle={colors.grey900}
                color={colors.primaryText}
                background={colors.grey50}
                total={dateToBr(dataCompraAntiga)}
              >
                Compra mais antiga
              </CardDashboard>
              <CardDashboard
                colorTitle={colors.white}
                color={colors.white}
                background={colors.grey200}
                total={`${diasConsumo} dias.`}
              >
                Dias de consumo
              </CardDashboard>
            </>
          )}
        </ContainerCards>
        <ContainerTable>
          <TableProductDetailsPrediction
            headers={[
              // 'ID',
              'Reposição Total',
              'Consumo médio diário',
              'Qtde. ult. compra',
              'Duração ult. compra',
              'Predição próx. compra',
            ]}
          >
            {/* {isLoading ? (
            <Loading contrast={false} />
          ) : ( */}
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <tr>
                <td>{reposicaoTotal}</td>
                <td>{String(consumoMedio).replace('.', ',')}</td>
                <td>{quantidadeUltimaCompra}</td>
                <td>{`${duracaoUltimaCompra} dias.`}</td>
                <td>{dateToBr(predicaoProximaCompra)}</td>
              </tr>
            )}
          </TableProductDetailsPrediction>
        </ContainerTable>
      </SendStyle>
    </ContainerModalSend>
  )
}
